import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ApartmentService} from "../../services/apartment.service";
import {AsyncPipe, DatePipe} from "@angular/common";
import {LabeledComponent} from "../../components/labeled/labeled.component";
import {PrimeTemplate} from "primeng/api";
import {ReactiveFormsModule} from "@angular/forms";
import {TableModule} from "primeng/table";
import {TypedTableRowDirective} from "../../typed-table-row.directive";

@Component({
  selector: 'app-apartment-page',
  imports: [
    AsyncPipe,
    DatePipe,
    LabeledComponent,
    PrimeTemplate,
    ReactiveFormsModule,
    TableModule,
    TypedTableRowDirective
  ],
  templateUrl: './apartment-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApartmentPageComponent {
  public readonly apartmentId = input.required<string>();

  private readonly apartmentService = inject(ApartmentService);
  public readonly apartment$ = computed(
    () => this.apartmentService.getApartment(this.apartmentId())
  )
}
